import { ZAZZLE_CONFIG, ZazzleProductType } from '../config/zazzle';

/**
 * Builds a Zazzle Create-A-Product URL for a specific product template.
 * Opens the product with the provided image pre-loaded.
 */
export function buildZazzleUrl(
  imageUrl: string,
  productType: ZazzleProductType,
  filename: string
): string {
  const { accountId, templates } = ZAZZLE_CONFIG;
  const template = templates[productType];

  const imageParamName = `t_${template.imageParam}_iid`;

  const params = new URLSearchParams({
    pd: template.id,
    ed: 'true',
    ax: 'Linkover',
  });

  // Encode the image URL once
  const encodedImageUrl = encodeURIComponent(imageUrl);

  return `https://www.zazzle.com/api/create/at-${accountId}?${params.toString()}&${imageParamName}=${encodedImageUrl}`;
}
